import { invariant } from '@streem/toolbox';
import { filter, take, tap, timeout } from 'rxjs/operators';
import { logger } from '../logger';
import { takeFirstEmitted } from './take_first_emitted';
export async function artifactTimedDeletion(artifactId, artifacts, timeoutMs = 10000) {
    invariant(timeoutMs > 0, 'Timeout must be greater than 0ms');
    await takeFirstEmitted(artifacts.pipe(filter(current => current.every(cur => cur.id !== artifactId)), tap(() => logger.info(`Artifact ${artifactId} has been deleted`)), timeout(timeoutMs), take(1)));
}
//# sourceMappingURL=artifact_timed_deletion.js.map